<template>
  <div>
    <!-- <div class="fwpj_box">
      <div class="myd">
        <p>服务满意度</p>
        <van-rate v-model="myd" color="#ECB57C" readonly />
      </div>
      <div class="zyd">
        <p>服务满意度</p>
        <van-rate v-model="zyd" color="#ECB57C" readonly />
      </div>
    </div> -->
    <div id="bodyFont" ref="bodyFont" class="bodyFont clearfloat">
      <div
        class="content_box"
        :class="{ bodyHeight: !contentStatus }"
        v-html="content"
      ></div>
    </div>
    <div
      v-if="content.length > 50"
      class="contentToggle"
      @click="contentStatus = !contentStatus"
    >
      {{ contentStatus ? '收起' : '全文' }}
    </div>
    <!-- <div v-if="dataImg" class="img_box">
      <van-image
        v-for="(item, index) in dataImg"
        :key="index + 'm'"
        class="img"
        fit="cover"
        height="74"
        lazy-load
        :src="item"
        width="74"
        @click="HandleclickImg(index)"
      />
    </div>
    <p class="text_data">2022-10-05 16:00:00</p> -->
  </div>
</template>

<script>
  import { ImagePreview } from 'vant'
  export default {
    props: {
      // eslint-disable-next-line vue/require-default-prop
      content: {
        type: String,
      },
    },
    data() {
      return {
        myd: 0,
        zyd: 0,
        contentStatus: false,
      }
    },
    mounted() {},
    methods: {
      HandleclickImg(i) {
        ImagePreview({
          images: this.dataImg,
          startPosition: i,
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .fwpj_box {
    padding: 12px 0;
    .myd,
    .zyd {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      p {
        margin-right: 10px;
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #4f515f;
      }
    }
  }
  .text_data {
    font-size: 12px;
    color: #888;
    margin-bottom: 8px;
  }
  .bodyFont {
    font-size: 16px;
    color: #333;
    text-align: left;
    line-height: 21px;
    .content_box {
      font-size: 14px;
      color: rgb(63, 63, 63);
      word-break: break-all;
      a {
        color: yellow !important;
      }
    }
  }
  .bodyHeight {
    display: -webkit-box; /**对象作为伸缩盒子模型展示**/
    -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
    -webkit-line-clamp: 5; /**显示的行数**/
    height: 107px;
    overflow: hidden; /**隐藏超出的内容**/
  }
  .contentToggle {
    color: #b57e48;
    font-size: 16px;
    margin-top: 10px;
  }
  .img_box {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 15px;
    .img {
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
</style>
